export { appInitializerPreloadScopes } from './lib/app-initializer-preload-scopes';
export {
  type I18nInjectionToken,
  buildI18nInjectionToken,
  provideI18nScope,
} from './lib/provide-i18n-scope';
export { getTranslocoModule } from './lib/testing/get-transloco-module';
export { translocoProvider } from './lib/transloco.provider';
export { TRANSLOCO_LOADER_LOAD_EXTRA_NAMESPACE } from './lib/transloco-loader';
